import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CompareDateService {
  constructor(
  ) {}

  compareDates(dateStr: string): string {
    const inputDate = new Date(dateStr);
    const currentDate = new Date();

    const diffInTime = currentDate.getTime() - inputDate.getTime();
    const diffInDays = diffInTime / (1000 * 3600 * 24);

    if (diffInDays < 1) {
      const diffInHours = diffInTime / (1000 * 3600);
      return `${Math.floor(diffInHours)} hours ago`;
    } else if (diffInDays >= 1 && diffInDays < 2) {
      return 'Yesterday';
    } else if (diffInDays >=2 && diffInDays<=30) {
      return `${Math.floor(diffInDays)} days ago`;
    } else {
      return 'a month ago';
    }
  }


}
